import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { useFetchImages } from '../../../../hooks/useFetchImages';
import { useSearchQuery } from '../../../../hooks/useSearchQuery';
import getFreepikImages from '../../../../utils/api-images/getFreepikImages';
import getUrlImage from '../../../../utils/api-images/getUrlImage';
import LoadingSpinner from './Partials/LoadingSpinner';
import ImagesContainer from './Partials/ImagesContainer';
import Image from './Partials/Image';
import DescriptionSection from './Partials/DescriptionSection';

const Freepik = ({ setAppImage, maxHeight = '1450px' }) => {
  const [query, handleInputQuery] = useSearchQuery();
  const [detail, setDetail] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [{ images, loading }, more] = useFetchImages(query, getFreepikImages);

  const handleSelect = (img) => {
    const imageUrl = img.image?.source?.url;
    setSelectedImage(imageUrl);
    setDetail({
      name: img.author?.name || 'Unknown',
      authorPage: img.url,
      description: img.title
    });

    getUrlImage(imageUrl, setAppImage);
  };

  useEffect(() => {
    return () => {
      setDetail('');
      setSelectedImage(null);
    };
  }, [setDetail]);

  return (
    <>
      <main className="space-y-3">
        <TextField
          id="search"
          label="Search"
          value={query}
          onChange={handleInputQuery}
          className="w-full"
          autoComplete="off"
        />
        <ImagesContainer more={more}>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <div
              className="grid grid-cols-3 gap-3 overflow-y-auto"
              style={{ maxHeight }}>
              {images.map((img, index) => {
                const imageUrl = img.image?.source?.url;
                return (
                  <Image
                    key={index}
                    alt={img.author?.name || 'Unknown Author'}
                    src={imageUrl}
                    userPage={img.url}
                    selectImage={() => handleSelect(img)}
                    isSelected={selectedImage === imageUrl}
                  />
                );
              })}
            </div>
          )}
        </ImagesContainer>
      </main>
      <DescriptionSection
        title={'Freepik Gallery Description'}
        detail={detail}
      />
    </>
  );
};

export default Freepik;
